import ReactDOM from 'react-dom';
import React from 'react';
import { Controller } from 'stimulus';

import App from '../../App';
import ResourceFetcher from '../../helpers/common/ResourceFetcher';
import Kpi from '../../api/Kpi';
import ProgressTracker from '../../helpers/common/ProgressTracker';

export default class extends Controller {
    connect() {
        const resourceFetcher = this._getResourceFetcher();
        const api = this._getApi();
        const kpi = this._getKpi();
        const progressTracker = this._getProgressTracker(kpi);

        console.log("fetcher base:", resourceFetcher.baseurl);
        console.log("kpi base:", kpi.baseurl);

        ReactDOM.render(
            <React.StrictMode>
                <App
                    // @ts-ignore
                    api={api}
                    progressTracker={progressTracker}
                    resourceFetcher={resourceFetcher}
                />
            </React.StrictMode>
            ,
            this.element
        );
    }

    _getBaseResourceUrl() {
        return document.body.getAttribute("data-asset-url")
            || "./";
    }

    _getResourceFetcher() {
        return new ResourceFetcher(this._getBaseResourceUrl());
    }

    _getKpiUrl() {
        return document.body.getAttribute("data-save-progress-url")
            || "https://jsonplaceholder.typicode.com";
    }

    _getKpi() {
        return new Kpi(this._getKpiUrl());
    }

    /**
     * @param {Kpi} kpi 
     * @returns {ProgressTracker}
     */
    _getProgressTracker(kpi) {
        return new ProgressTracker(kpi);
    }

    /**
     * @returns {_Api | undefined}
     */
    _getApi() {
        return undefined;
    }

    /**
     * @returns {any}
     */
    _getApiUrls() {
        return document.body.getAttribute("data-api-url")
            || "https://jsonplaceholder.typicode.com";
    }
}